



































































































import { KesadaranGCS } from "@/types";
import { Component, Vue, Watch, Prop } from "vue-property-decorator";

@Component
export default class KesadaranGCSInput extends Vue {
  @Prop() readonly value: KesadaranGCS;
  @Prop() readonly showDescription = false;

  gcsEyeOptions = [
    { id: 1, name: "Tidak membuka mata" },
    { id: 2, name: "Dengan rangsangan nyeri" },
    { id: 3, name: "Dengan perintah suara" },
    { id: 4, name: "Spontan" },
    { id: 0, name: "NT" }
  ];
  gcsVerbalOptions = [
    { id: 1, name: "Tidak bersuara" },
    { id: 2, name: "Mengerang" },
    { id: 3, name: "Kata" },
    { id: 4, name: "Orientasi abnormal" },
    { id: 5, name: "Kalimat lengkap dan orientasi baik" },
    { id: 0, name: "NT" }
  ];
  gcsMotorOptions = [
    { id: 1, name: "Tidak bergerak" },
    { id: 2, name: "Response ekstensi abnormal" },
    { id: 3, name: "Response fleksi abnormal" },
    { id: 4, name: "Menjauhi nyeri" },
    { id: 5, name: "Melokalisir nyeri" },
    { id: 6, name: "Sesuai perintah" },
    { id: 0, name: "NT" }
  ];
  kesadaranLevelOpts = [
    { maxVal: 15, id: "cm", text: "Composmentis" },
    { maxVal: 13, id: "apatis", text: "Apatis" },
    { maxVal: 11, id: "delirium", text: "Delirium" },
    { maxVal: 9, id: "somnolen", text: "Somnolen" },
    { maxVal: 6, id: "sopor", text: "Sopor" },
    { maxVal: 4, id: "semi-coma", text: "Semi Coma" },
    { maxVal: 3, id: "coma", text: "Coma" }
  ];

  gcsEye = null;
  gcsVerbal = null;
  gcsMotor = null;

  selectProps = { openOnHover: true, offsetY: true };

  set gcs(val: KesadaranGCS) {
    this.gcsEye = typeof val?.e == "number" ? Number(val.e) : null;
    this.gcsVerbal = typeof val?.v == "number" ? Number(val.v) : null;
    this.gcsMotor = typeof val?.m == "number" ? Number(val.m) : null;
  }

  get gcs(): KesadaranGCS {
    return {
      e: this.gcsEye,
      v: this.gcsVerbal,
      m: this.gcsMotor
    };
  }

  get gcsEyeOpts() {
    return this.gcsEyeOptions.sort((a, b) => b.id - a.id);
  }

  get gcsVerbalOpts() {
    return this.gcsVerbalOptions.sort((a, b) => b.id - a.id);
  }

  get gcsMotorOpts() {
    return this.gcsMotorOptions.sort((a, b) => b.id - a.id);
  }

  get kesadaranText() {
    return this.kesadaranLevel?.text ?? "-";
  }

  get kesadaranLevel() {
    const gcs = this.gcsEye + this.gcsVerbal + this.gcsMotor;

    const val = this.kesadaranLevelOpts
      .sort((a, b) => a.maxVal - b.maxVal)
      .find(item => gcs <= item.maxVal);

    return val && this.gcsEye && this.gcsVerbal && this.gcsMotor ? val : null;
  }

  @Watch("kesadaranLevel")
  changeKesadaranLevel(val) {
    this.$emit("changeKesadaran", val);
  }

  @Watch("gcs", { deep: true })
  changeGCS(val) {
    this.$emit("changeGCS", val);
  }

  @Watch("value", { deep: true })
  changeValue(val) {
    console.log("change value gcs", val);
    this.gcs = JSON.parse(JSON.stringify(val));
  }
}
